import React, { FunctionComponent } from 'react';

import './ButtonGroup.scss';

export const ButtonGroup: FunctionComponent = (props) => {
  return <div className="button-wrap">{props.children}</div>;
};

export default ButtonGroup;
